export enum StatusCode {
  NAMING_CONFLICT = 409,
}
